// removed by extract-text-webpack-plugin
module.exports = {"newPersonContainer":"_2K48uCRyVADFnNh-3CzCp4","housemateIconContainer":"_1HT6SK9PpMXhSM9BSei9og","housemateIcon":"_3YvlpwSw-MZpa66lMSAhVm","addPerson":"_1HBjkLxMnyC8HGGqkgFcWu"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/AddMember.css
// module id = 371
// module chunks = 0